/** @jsx jsx */

import { ComponentProps, PropsWithChildren } from 'react';

import { Text } from '@zapier/design-system';
import { jsx, css } from '@emotion/core';

import ExtendedIcon from 'app/developer-v3/components/ExtendedIcon';

const Styles = {
  icon: css`
    display: inline-flex;
    margin-right: 10px;
    vertical-align: text-top;
  `,
  root: css`
    display: inline-flex;
    align-items: center;
  `,
};

type Props = PropsWithChildren<{
  icon: ComponentProps<typeof ExtendedIcon>['name'];
}>;

export default function Title({ children, icon }: Props) {
  return (
    <Text css={Styles.root} tag="h2" type="Body4">
      <span css={Styles.icon}>
        <ExtendedIcon color="GrayWarm7" name={icon} size={20} />
      </span>
      {children}
    </Text>
  );
}
